import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
    Box,
    VStack,
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';

import AvailableServiceProfiles from './add/AvailableServiceProfiles';
import getAvailableServiceProfiles from 'API/ServiceProfiles/getAvailableServiceProfiles';

import styles from './styles';
import { breadCrumbStyling } from 'components/forms/new/formStyles';

/**
 * @param {object} props
 * @param {string} [props.autoConfirmServiceProfileID] - (3135) opens this
 *   service's confirmation as soon as its card shows ("+ Add now")
 * @param {boolean} [props.isExistingServicesPending] - the company's current
 *   services have not been fetched yet
 * @param {boolean} [props.isNewDashboard] - (2635) opened from
 *   /dashboard-services/new, which words the confirmation as a question
 */
const ServiceWizard = ({
    serviceWizard,
    existingServices,
    isExistingServicesPending,
    autoConfirmServiceProfileID,
    isNewDashboard = false,
}) => {
    // Global
    const { currentCompany } = useSelector((state) => state.navigationLists);

    // Local
    const [serviceProfiles, setServiceProfiles] = useState(null);

    useEffect(() => {
        const handleGetData = async () => {
            if (currentCompany) {
                const serviceprofiles =
                    await getAvailableServiceProfiles(currentCompany);
                setServiceProfiles(serviceprofiles);
            }
        };

        handleGetData();
    }, [currentCompany]);

    const titleName = 'Add New Service';
    const breadCrumbTrail = [
        {
            label: 'Dashboard Services',
            path: '',
        },
        {
            label: titleName,
            path: '',
        },
    ];

    return (
        <Box sx={styles.container}>
            <Breadcrumb sx={breadCrumbStyling}>
                {breadCrumbTrail?.map((crumb, index) => (
                    <BreadcrumbItem key={index}>
                        <BreadcrumbLink
                            as={Link}
                            to={crumb.path}
                            onClick={() =>
                                index === 0 && serviceWizard.reset()
                            }>
                            {crumb.label}
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                ))}
            </Breadcrumb>
            <VStack align="flex-start" width="100%">
                <AvailableServiceProfiles
                    serviceProfiles={serviceProfiles}
                    serviceWizard={serviceWizard}
                    existingServices={existingServices}
                    isExistingServicesPending={isExistingServicesPending}
                    autoConfirmServiceProfileID={autoConfirmServiceProfileID}
                    isNewDashboard={isNewDashboard}
                />
            </VStack>
        </Box>
    );
};

export default ServiceWizard;
